import React from "react";
import {Button, Col, Form, Row, FormGroup, Input} from "reactstrap";
import Axios from "axios";
import Select from 'react-select';
import { css } from "@emotion/core";
import baseURL from "../../../config";
import {Link} from 'react-router-dom';
import { downloadPregnancyRecord, getPregnancyRecord, deletePregnancyRecord } from '../../services'
import { downloadFile } from '../../../utils'
import  CurrentPregnancy from './CurrentPregnancy'
import  PreviousPregnancy from './PreviousPregnancy'
import PrePregnancy from './PrePregnancy';
import { showConfirmation, showSuccess } from '../../../utils/alerts';
import Loader from "../../Loader";

const options = [
  { value: 1, label: 'Previous Pregnancy (History)', category: 'documentDetails.documentType' },
  { value: 2, label: 'Current Pregnancy (Pregnant)', category: 'pregnancyStage' },
  { value: 3, label: 'Pre-Pregnacy (Trying to concieve)', category: 'documentDetails.documentType' }
]

class ViewpregnancyRecord extends React.Component {
  state = {
    activeTab: "1",
    loading: true,
    pageOfItems: [],
    currentRecord: [],
    currentPage: null,
    pageLimit: 10,
    totalPages: null,
    successmsg: '',
    errormsg: '',
    collapse: null,
    pregnancyType: "Current Pregnancy (Pregnant)",
    pregnancyRecord: {}
  };


  onChangePage = pageOfItems => {
    this.setState({pageOfItems: pageOfItems});
  };

  onPageChanged = data => {
    const {pregnancyRecord} = this.state;
    const {currentPage, totalPages, pageLimit} = data;
    const offset = (currentPage - 1) * pageLimit;
    const currentRecord = pregnancyRecord.slice(offset, offset + pageLimit);
    this.setState({currentPage, currentRecord, totalPages});
  };

  async componentDidMount() {

    await this.getPregnancyRecord(options[0])
  }

  handleDelete = async (week, recordId) => {
    const result = await showConfirmation("Yes, delete it!")
    if(result.value == true) {
      await deletePregnancyRecord({data: { recordId }});

      const { pregnancyRecord } = this.state;
      pregnancyRecord[week] = pregnancyRecord[week].filter((record) => record._id !== recordId)

      this.setState(prevState => ({
        pregnancyRecord: {...pregnancyRecord}
      }))
      await showSuccess("success", "Deleted!", "Your file has been deleted");
    }
    
  }

  getPregnancyRecord = async (selectedOption) => {
    try {

      let res = await getPregnancyRecord({ type: selectedOption['value'], category: selectedOption['category'] });

      let pregnancyRecord = {};
      res.data.records.forEach((record) => {
        pregnancyRecord[record['documentDetails']['documentType']] = pregnancyRecord[record['documentDetails']['documentType']] || [];
        pregnancyRecord[record['documentDetails']['documentType']].push(record);
      })
      
      this.setState({pregnancyRecord: pregnancyRecord, loading: false, pregnancyType: selectedOption['value'] })
        

    } catch (err) {
      this.setState({loading: false, errormsg: err.message});
    }
  }


  handleView = (pregnancyType, pregnancyRecord) => {
    if (pregnancyType === 2) {
      return <CurrentPregnancy 
        pregnancyRecord={pregnancyRecord} 
        handleDelete={this.handleDelete}
        handleDownload={this.handleDownload}
      />
    }
    if (pregnancyType === 1) {
      return <PreviousPregnancy 
        pregnancyRecord={pregnancyRecord} 
        handleDelete={this.handleDelete}
        handleDownload={this.handleDownload}
      />
    }
    if (pregnancyType === 3) {
      return <PrePregnancy 
        pregnancyRecord={pregnancyRecord} 
        handleDelete={this.handleDelete}
        handleDownload={this.handleDownload}
      />
    }

  }

  handleChange = (selectedOption) => {
    this.getPregnancyRecord(selectedOption)
  }


  // componentDidUpdate(prevProps, prevState, snapshot) {
  //   if(prevState.pregnancyType !== this.state.pregnancyType ){
  //         this.getPregnancyRecord()
  //   }
  // }

  handleDownload = async (recordId) => {
    let data = {
      recordId
    }

    const response = await downloadPregnancyRecord(data);
    console.log(response.data);
    downloadFile(response.data, "Pregnancy_Record");

    
  }

  render() {
    const {pregnancyRecord, pregnancyType, successmsg, errormsg} = this.state;
    // const totalRecord = pregnancyRecord.length;
    // const totalPages = Math.ceil(totalRecord / pageLimit);
    // console.log(pregnancyRecord)

    if (this.state.loading) {
      return (
        <Loader />
      );
    }

      return (
        <React.Fragment>
          <Form>
            <Row className="mt-3">
              <Col xs="12" className="col-md-4">
                <FormGroup>
                  <Select
                    defaultValue={options[0]} 
                    options={options}
                    onChange={this.handleChange}
                  />
                  {/* <Input
                    type="select"
                    name="deseaseType"
                    onChange={(e) => this.setState({pregnancyType: e.target.value})}>
                    <option>Previous Pregnancy (History)</option>
                    <option>Pre-Pregnancy (Trying to concieve)</option>
                    <option>Current Pregnancy (Pregnant)</option>
                  </Input> */}
                </FormGroup>
              </Col>
            </Row>
          </Form>
          {this.handleView(pregnancyType, pregnancyRecord)}
          <div className="text-center mt-4">
          </div>
        </React.Fragment>
      )


    // if(!successmsg && errormsg){
    //   return <div>{errormsg}</div>
    // }
  }
}




export default ViewpregnancyRecord;





// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/PregnancyRecord/ViewpregnancyRecord.js